import type { ReactNode } from 'react';
import { cx } from '../lib/cx';
import styles from './Prompt.module.css';

type Props = {
  /** Working directory shown after the colon. */
  path?: string;
  className?: string;
  children?: ReactNode;
};

/** `seax@dev:~$ <cmd>` — a shell prompt line inside a TerminalWindow. */
export function Prompt({ path = '~', className, children }: Props) {
  return (
    <div className={cx(styles.line, className)}>
      <span className={styles.user}>seax@dev</span>
      <span className={styles.path}>:{path}$</span>
      {children !== undefined && <> {children}</>}
    </div>
  );
}
